import { useContext } from 'react'

import { BPRegistrationTranslationCodes } from 'onboarding/configs/translations/bpRegistrationTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import styles from './DisplayRejectionReason.module.scss'

// these are keys that saved in db as rejection reason to map translation
export enum RejectionReasonTranslationKey {
  RequestWasRejected = 'bpreg-regect-text',
  CompanyNotConfirmed = 'bpreconfirm_not_my_company',
  EmailNotRegistered = 'bpreconfirm_email_used_not_eligile',
}

const mapReasonToTranslationKey = (
  reason: RejectionReasonTranslationKey | string,
  defaultKey: BPRegistrationTranslationCodes = BPRegistrationTranslationCodes.regect_text
) => {
  const { RequestWasRejected, CompanyNotConfirmed, EmailNotRegistered } =
    RejectionReasonTranslationKey

  const map = {
    [RequestWasRejected]: BPRegistrationTranslationCodes.regect_text,
    [CompanyNotConfirmed]: BPRegistrationTranslationCodes.not_my_company,
    [EmailNotRegistered]: BPRegistrationTranslationCodes.email_used_not_eligile,
  }

  return map[reason] || defaultKey
}

const rejectReasons = (text: string, t: (key: string) => string) => {
  if (text === RejectionReasonTranslationKey.CompanyNotConfirmed) {
    return (
      <div>
        {t(BPRegistrationTranslationCodes.not_my_company_thank_you)}
        <br />
        {t(BPRegistrationTranslationCodes.not_my_company_check_info)}
        <br />
        {t(BPRegistrationTranslationCodes.regards_thank_you)}
        <span>,</span>
        {t(BPRegistrationTranslationCodes.team_name)}
      </div>
    )
  }
  if (text === RejectionReasonTranslationKey.EmailNotRegistered) {
    return (
      <div>
        {t(BPRegistrationTranslationCodes.email_used_not_eligile)}
        <br />
        {t(BPRegistrationTranslationCodes.email_used_not_eligile_use_invite_email)}
        <br />
        {t(BPRegistrationTranslationCodes.regards_thank_you)}
        <span>,</span>
        {t(BPRegistrationTranslationCodes.team_name)}
      </div>
    )
  }

  return t(mapReasonToTranslationKey(text))
}

interface IProps {
  text: RejectionReasonTranslationKey | string
}

export const DisplayRejectionReason = ({ text }: IProps) => {
  const { t } = useContext(LanguageContext)

  return (
    <div className={styles.completed_dialog__content}>
      <div className={styles.completed_dialog__header}>
        <p className={styles.text_center}>{rejectReasons(text, t)}</p>
      </div>
    </div>
  )
}
